import React from 'react';
import { Search, Database } from 'lucide-react';

const SearchPanel = ({ 
  apiKey, 
  api, 
  searchInput, 
  setSearchInput, 
  onSearch, 
  loading, 
  onKeyPress 
}) => {
  return (
    <div className="card">
      <div className="p-6">
        <div className="flex items-center mb-4">
          <div className={`w-3 h-3 rounded-full ${api.color} mr-3`}></div>
          <h3 className="font-medium text-gray-900">{api.name}</h3>
        </div>
        
        <div className="space-y-4">
          <div>
            <input
              type="text"
              className="input-field"
              placeholder={`Digite o ID da cobrança (ex: PC-834271)`}
              value={searchInput || ''}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyPress={onKeyPress}
              disabled={loading}
            />
          </div>
          
          <button
            className="btn-primary w-full flex items-center justify-center space-x-2"
            onClick={onSearch}
            disabled={loading}
          >
            {loading ? (
              <div className="loading-spinner w-5 h-5" />
            ) : (
              <Search className="w-5 h-5" />
            )}
            <span>{loading ? 'Buscando...' : 'Buscar Unificado'}</span>
          </button>
          
          <div className="text-xs text-gray-500 text-center">
            <Database className="w-4 h-4 inline mr-1" />
            Busca automática: parcelas → direto → padrão
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchPanel;
